// @flow
import * as React from 'react';
import { Item, Input, Icon, Toast, Form, ListItem, Label, Switch, View } from 'native-base';
import { Keyboard } from 'react-native';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import Login from './login';
import { doLogin } from './actions';
//import renderInput from './renderInput';
import { renderCheckbox, textInput } from '../../forms/renderedComponents';
import LocalStorage from '../../api/LocalStorage';

const required = value => (value ? undefined : 'Required');
const maxLength = max => value => (value && value.length > max ? `Must be ${max} characters or less` : undefined);
const maxLength15 = maxLength(16);
const minLength = min => value => (value && value.length < min ? `Must be ${min} characters or more` : undefined);
const minLength6 = minLength(6);
const email = value => (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Invalid email address' : undefined);
const alphaNumeric = value => (value && /[^a-zA-Z0-9 \-]/i.test(value) ? 'Only alphanumeric characters' : undefined);

class LoginForm extends React.Component<Props, State> {
	constructor(props) {
		super(props);

		this.state = {
			remember: true,
			preFilled: false
		};
	}

	componentDidMount() {
		this.fillCreds();
	}

	async fillCreds() {
		const creds = await LocalStorage.getCredsAsync();
		//console.log('LOCAL creds: ',creds);
		if (creds) {
			this._changeFormVal('email', creds.user);
			this._changeFormVal('password', creds.pass);
			this.setState({ preFilled: true });
		}
	}

	_changeFormVal(field, val) {
		//console.log('setting ', field, val);
		this.props.dispatch(change('login', field, val));
	}

	login() {
		if (this.props.valid) {
			Keyboard.dismiss();
			//console.log(this.props.formVals);

			var vals = {
				pass: this.props.formVals.password,
				user: this.props.formVals.email,
				remember: this.state.remember
			};

			this.props.doLogin(vals);
			//this.props.navigation.navigate("Drawer");
		} else {
			Toast.show({
				text: 'Enter valid username & password!',
				duration: 2000,
				position: 'bottom',
				textStyle: { textAlign: 'center' }
			});
		}
	}

	componentWillUpdate(nextProps) {
		//console.log('isLoginSuccess', nextProps.isLoginSuccess);
		//console.log('loginError', nextProps.loginError);
		//if(nextProps.isLoginSuccess)  this.props.navigation.navigate("Drawer");
		if (nextProps.loginError) {
			Toast.show({
				text: 'Login failed - ' + nextProps.loginError,
				position: 'top',
				type: 'danger',
				duration: 2000,
				textStyle: { textAlign: 'center' }
			});
			this.props.dispatch({
				type: 'SET_LOGIN_ERROR',
				loginError: false
			});
			/*tryNavigationActions.reset({
            // this says put it on index 0, aka top of stack
            index: 0,
            // this key: null is 9001% critical, this is what
            // actually wipes the stack
            key: null,
            // this navigates you to some screen that is in the Root Navigation Stack
            actions: [NavigationActions.navigate({ name: 'SomeRootScreen' })]
        })*/
		}
	}
	render() {
		//let {authenticated} = this.props;

		if (!this.props.formVals.password && this.state.preFilled) this.setState({ preFilled: false }); //once password deleted, allow spy again

		const form = (
			<Form ref="form" style={{ marginHorizontal: 10 }}>
				<Field
					name="email"
					component={textInput}
					keyboardType="email-address"
					placeholder="Email / Username"
					validate={[required]}
					labelType="inline"
					icon="ios-person"
					returnKeyType="next"
					onEnter={() => {
						//console.log('next??');
						this.password.getRenderedComponent().refs.input._root.focus();
					}}
				/>
				<Field
					name="password"
					labelType="inline"
					icon="ios-unlock"
					placeholder="Password"
					component={textInput}
					secureTextEntry
					allowInsecure={!this.state.preFilled}
					returnKeyType="done"
					forwardRef
					ref={ref => (this.password = ref)}
					forwardRef
					validate={[minLength6, required]}
					onEnter={() => {
						this.login();
					}}
				/>
				<Field style={{ marginHorizontal: 20 }} ref={c => (this.remember = c)} component={renderCheckbox} label="Remember me" name="saveuser" />
			</Form>
		);
		//console.log('render loginContainer', this.state.focusField);
		return <Login navigation={this.props.navigation} isLoading={this.props.isLoginPending} loginForm={form} onLogin={() => this.login()} />;
	}
}
const LoginContainer = reduxForm({
	form: 'login',
	initialValues: { saveuser: true }
})(LoginForm);

/*
// create new, "configured" function
createReduxForm = reduxForm({ form: 'contact' })

// evaluate it for ContactForm component
ContactForm = createReduxForm( ContactForm )
*/

//const selector = formValueSelector('login');

function bindAction(dispatch) {
	return {
		doLogin: url => dispatch(doLogin(url))
	};
}

const selector = formValueSelector('login');

const mapStateToProps = state => ({
	isLoginPending: state.loginReducer.isLoginPending,
	isLoginSuccess: state.loginReducer.isLoginSuccess,
	loginError: state.loginReducer.loginError,
	formVals: selector(state, 'email', 'password')
});

export default connect(mapStateToProps, bindAction)(LoginContainer);
